const geoEligibleCountryCodes = [
  'US',
  'CA',
  'AU',
  'NZ',
  'UK',
  'IE',
  'MX',
  'BR',
  'CL',
  'CO',
  'PE',
  'DZ',
  'BE',
  'CIV',
  'CI',
  'DO',
  'FR',
  'GF',
  'PF',
  'TF',
  'GP',
  'LU',
  'MV',
  'MQ',
  'YT',
  'MC',
  'MA',
  'NC',
  'PH',
  'RE',
  'SH',
  'LC',
  'PM',
  'VC',
  'SN',
  'CH',
  'TN',
  'WF',
  'AT',
  'DE',
  'LI',
  'DK',
  'FI',
  'IS',
  'NL',
  'NO',
  'SE',
  'AX',
  'GL',
  'AL',
  'AM',
  'BY',
  'BA',
  'BA',
  'BG',
  'HR',
  'CY',
  'CZ',
  'EE',
  'GE',
  'HU',
  'KZ',
  'LV',
  'LT',
  'MK',
  'MD',
  'PL',
  'RO',
  'RU',
  'RS',
  'SK',
  'SI',
  'UA',
  'GB',
];

export default geoEligibleCountryCodes;
